export default {
  computed: {
    dev () {
      return this.$store.getters.dev;
    },
    number () {
      return Number(this.$store.getters.number) - 1;
    },
    sets () {
      return this.$store.getters.sets;
    },
    view () {
      return Number(this.$store.getters.view);
    },
    clothes () {
      return Boolean(this.$store.getters.clothes);
    },
    slititems () {
      return this.$store.getters.slititems;
    },
    railitems () {
      return this.$store.getters.railitems;
    },
    partsitems () {
      return this.$store.getters.partsitems;
    },
    loginUser () {
      return this.$store.getters.loginUser;
    },
    spanitems () {
      return this.$store.getters.spanitems;
    },
    formstatus () {
      return this.$store.getters.formstatus;
    },
    preview () {
      return this.$store.getters.preview;
    },
    config () {
      return this.$store.getters.config;
    },
    category () {
      return this.$store.getters.category;
    },
    railsspan () {
      return this.$store.getters.railsspan;
    },
    drag () {
      return this.$store.getters.drag;
    },
    axiosConfig () {
      return {
        headers: {
          // 'Content-Type': 'application/json;charset=UTF-8',
          // 'Access-Control-Allow-Origin': '*',
          // 'withCredentials': true,
          'X-API-KEY': '0imfnc8mVLWwsAawjYr4Rx-Af50DDqtlx'
        }
      };
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    c2p (num) {
      // cm to px
      return (50 / 15) * Number(num);
    },
    p2c (num) {
      // px to cm
      return Number(num) * 15 / 50;
    },
    acopy (ary) {
      return JSON.parse(JSON.stringify(ary));
    },
    addComma (num) {
      return String(num).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    mouseSlit (e) {
      let me = this;
      // ドラック要素がどのスリット内か調べる
      let chk = -1;
      // let elements = document.querySelectorAll('.items-area .slit .items');
      let elements = document.querySelectorAll('.items-area .slit');
      elements.forEach(function (userItem, i) {
        let rect = userItem.getBoundingClientRect();
        if (rect.x < me.mp(e).clientX && rect.x + rect.width > me.mp(e).clientX) {
          if (rect.y < me.mp(e).clientY && rect.y + rect.height > me.mp(e).clientY) {
            chk = i;
          }
        }
      });
      return chk;
    },
    mouseItems (e) {
      let me = this;
      // ドラック要素がどのスリット内か調べる
      let chk = -1;
      // let elements = document.querySelectorAll('.items-area .slit .items');
      let elements = document.querySelectorAll('.items-area .slit .items');
      elements.forEach(function (userItem, i) {
        let rect = userItem.getBoundingClientRect();
        if (rect.x < me.mp(e).clientX && rect.x + rect.width > me.mp(e).clientX) {
          if (rect.y < me.mp(e).clientY && rect.y + rect.height > me.mp(e).clientY) {
            chk = i;
          }
        }
      });
      return chk;
    },
    updateSlit (set) {
      let isLargeNumber;
      let color = this.sets[this.number].color;
      // スリットの商品を調べる
      if (this.sets.length > 0 && set !== undefined) {
        let num = Math.round(this.sets[this.number].size[1] * 10) / 10;
        if (color === 1) {
          isLargeNumber = function (element) {
            let bk = element.code.substr(element.code.length - 2, 2);
            if (Number(element.pos) === Number(num) && bk === 'BK') {
              return element;
            }
          };
        } else {
          isLargeNumber = function (element) {
            if (Number(element.pos) === Number(num)) {
              return element;
            }
          };
        }
        let item = this.acopy(this.slititems.find(isLargeNumber));
        for (let prop in set.slits) {
          set.slits[prop].slit = this.acopy(item);
        }
      }
    },
    updateFix () {
      // 横幅
      let wt = 0;
      for (let prop in this.set.rails) {
        wt += this.set.rails[prop].w + 1.5;
      }
      this.fixWidth = wt + 1.5;
      // 奥行
      this.fixDepth = 0;
      for (let prop in this.set.slits) {
        let itm = this.set.slits[prop].item;
        for (let prop2 in itm) {
          if (this.fixDepth < itm[prop2].d) {
            this.fixDepth = itm[prop2].d;
          }
        }
      }
      let fix = [
        this.fixWidth,
        this.sizeHeight,
        this.fixDepth
      ];
      this.$set(this.set, 'fix', fix);
    },
    checkTop (code) {
      let tp = 0;
      let code2 = code.substr(0, 2);
      let code3 = code.substr(0, 3);
      if (code2 === 'TP' ||
          code2 === 'TS' ||
          code2 === 'LD' ||
          code2 === 'HB' ||
          code3 === 'UHB' ||
          code3 === 'GHB'
      ) {
        tp = 3;
      } else {
        tp = 2;
      }
      return tp;
    },
    checkDate () {
      let year = document.querySelector('[name="user_year"]').value;
      let month = document.querySelector('[name="user_month"]').value;
      let day = document.querySelector('[name="user_day"]').value;

      let nyear = new Date().getFullYear();
      let nmonth = new Date().getMonth();
      let nday = new Date().getDate();

      let time = new Date(year, month - 1, day, 0).getTime();
      let ntime = new Date(nyear, nmonth, nday + 10, 0).getTime();
      if (time < ntime) {
        let msg = {};
        msg.user_year = ['本日より10日後以降の日付を指定してください'];
        return {
          chk: true,
          msg: msg
        };
      } else {
        let msg = {};
        return {
          chk: false,
          msg: msg
        };
      }
    },
    mp (e) { // mouse position
      return {
        clientX: e.clientX || e.changedTouches[0].clientX,
        clientY: e.clientY || e.changedTouches[0].clientY
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/index.js